<template>
  <div class="navbar_container">
    <div class="navbar limitW">
      <div class="burgerMenu .noSelect" @click="showNav">
        <i class="fas fa-bars noSelect"></i>
      </div>

      <div class="title">
        <router-link @click="inicio" to="/scanner">
          <img :src="logo" alt="logo rastreabilidade" />
        </router-link>
      </div>

      <div class="notify" @click="showNotify">
        <i class="fas fa-bell"></i>
      </div>
    </div>
  </div>

  <Loading />
  <div class="menu" :class="{ show: showMenu }">
    <div class="container_link">
      <ul>
        <div class="titleMenu">
          <p>Telas de acesso</p>
        </div>
        <li>
          <router-link to="/all" @click="showNav"
            ><i class="fas fa-plus"></i> Todas embalagens</router-link
          >
        </li>
        <li>
          <router-link to="/lista-manutencao" @click="showNav"
            ><i class="fas fa-wrench"></i> Em manutenção</router-link
          >
        </li>
        <li>
          <router-link to="/dashboard" @click="showNav"
            ><i class="fas fa-chart-line"></i> Dashboard</router-link
          >
        </li>
        <div class="titleMenu">
          <p>Outros</p>
        </div>
        <li>
          <router-link to="/config" @click="showNav"
            ><i class="fas fa-cog"></i> Configuração</router-link
          >
        </li>
        <li>
          <router-link to="/" @click="showNav"
            ><i class="fas fa-door-open"></i> Sair</router-link
          >
        </li>
      </ul>
      <div class="marca">
        <img :src="tutilabs" alt="tutilabs" />
      </div>
    </div>
  </div>

  <!-- notificação -->
  <div class="menuNotify" :class="{ showNoti: showNoti }">
    <div class="container_link container_notify">
      <div class="container_filter">
        <div
          class="filter"
          @click="myFilterStopped"
          :class="{ showFilter: showStopped }"
        >
          <p>Parado</p>
        </div>
        <div
          class="filter"
          @click="myFilterManut"
          :class="{ showFilter: showManut }"
        >
          <p>Manutenção</p>
        </div>
      </div>
      <div class="scrollFilter">
        <Stopped v-if="showStopped" />
        <NotifiManut v-else />
      </div>
    </div>
  </div>

  <div class="bgMenu" :class="{ showBgMenu: showMenu }"></div>
  <div class="bgMenu" :class="{ showBgMenu: showNoti }"></div>
</template>
<script>
import Loading from "./Loading.vue";
import Stopped from "@/components/Notification/Stopped.vue";
import NotifiManut from "@/components/Notification/NotifiManut.vue";

import logo from "../assets/image/logo.svg";
import tutilabs from "../assets/image/tutilabs.svg";

export default {
  components: {
    Loading,
    Stopped,
    NotifiManut,
  },
  data: () => {
    return {
      showMenu: false,
      showNoti: false,
      showStopped: true,
      showManut: false,
      logo,
      tutilabs,
    };
  },
  methods: {
    showNav() {
      this.showMenu = !this.showMenu;
      this.showBgMenu = !this.showBgMenu;

      this.showNoti = false;

      this.myscroll(this.showMenu);
    },
    showNotify() {
      this.showNoti = !this.showNoti;
      this.showMenu = false;

      this.myscroll(this.showNoti);
    },

    myscroll(value) {
      let body = document.querySelector("body");

      if (value === true) {
        return (body.style.overflow = "hidden");
      }
      body.style.overflow = "";
    },

    Home() {
      this.$router.push("/home");
    },
    myFilterStopped() {
      this.showStopped = true;
      this.showManut = false;
    },
    myFilterManut() {
      this.showManut = true;
      this.showStopped = false;
    },
    inicio() {
      let body = document.querySelector("body");

      body.style.overflow = "";

      this.showMenu = false;
      this.showBgMenu = false;
      this.showNoti = false;
    },
  },
};
</script>

<style scoped>
.navbar {
  padding: 0 1rem;

  height: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}

.navbar_container {
  position: fixed;
  width: 100%;
  background: var(--bgColor);
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.253);
  z-index: 9999;
}
.navbar_container .title {
  color: var(--colorPrimary);
}
.title {
  width: 7rem;
  height: 100%;
  display: flex;
  align-items: center;
}

.title a img {
  width: 100%;
}
/* menu lateral ==============================================*/
.burgerMenu {
  font-size: 2rem;
  cursor: pointer;
}
.menu {
  background: var(--white);
  height: 100%;
  width: 0px;
  transition: 0.2s;
  z-index: 10;
  display: grid;
  align-items: center;
  position: fixed;
  overflow: hidden;
}
.show {
  width: 500px;
}
.bgMenu {
  z-index: 0;
  width: 100%;
  height: 100vh;
  position: fixed;
}

.showBgMenu {
  z-index: 9;
  transition: 0.5s;

  background: #020e484d;
  backdrop-filter: blur(5px);
}
.container_link {
  height: 75vh;
}
.titleMenu {
  padding: 1rem 0.5rem;
  color: var(--colorPrimary);
  font-weight: 700;
}
li {
  font-size: 1.3rem;
  font-weight: 700;
  background: var(--bgColor);
}
li a {
  color: var(--colorText-default);
  display: flex;
  width: 100%;
  padding: 0.5rem 1rem;
  gap: 0.5rem;
}

li:hover {
  background: var(--colorPrimary);
}
li:hover a {
  color: var(--white);
}
/* notificação ==========================================================*/
.container_filter {
  display: flex;
  gap: 2rem;
  padding: 1rem 0;
}
.container_filter p {
  font-weight: 600;
}
.filter {
  background: var(--colorFilterButton);
  margin-right: 0.5rem;
  padding: 0.3rem;

  text-align: center;
  border-radius: 1rem;
  cursor: pointer;
}
.showFilter {
  background: var(--colorPrimary);
  color: var(--white);
}
.notify {
  font-size: 1.5rem;
  cursor: pointer;
}
.container_notify {
  color: var(--colorText-secondary);
  padding: 0 2vw;
}
.titleNotify {
  width: 100%;
  border-bottom: 2px solid rgba(0, 0, 0, 0.116);
  padding: 1rem 0;
}
.titleNotify h2 {
  margin-bottom: 1rem;
}
.listNotify {
  display: flex;
  justify-content: space-between;
  height: 3rem;
  align-items: center;
}

.notifyNumber {
  display: flex;
  align-items: center;
}

.notifyNumber h1 {
  color: var(--colorPrimary);
  font-size: 2.2rem;
  display: flex;
}
.notifyName h1 {
  font-size: 1rem;
  text-transform: uppercase;
}
.alertIcon {
  background: var(--notifyDelay);
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}
.alert {
  width: 2rem;
  display: flex;
  justify-content: center;
}

.menuNotify {
  background: var(--white);
  height: 100%;
  width: 0px;
  transition: 0.2s;
  z-index: 10;
  display: grid;
  align-items: center;
  position: fixed;
  right: 0;
  overflow: hidden;
}
.showNoti {
  width: 500px;
}
.scrollFilter {
  overflow-y: scroll;
  height: 100%;
}

.marca {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.marca img {
  width: 7rem;
  height: 7rem;
}

@media only screen and (max-width: 600px) {
  .show,
  .showNoti {
    width: 80%;
  }
  .navbar {
    height: 3rem;
  }
  li {
    font-size: 0.9rem;
  }
  .titleMenu {
    padding: 0.5rem;
  }

  .filter {
    padding: 0.6rem;
  }
}
</style>
